<mat-toolbar class="ribbon">
  <div class="ribbon-wrap">
    <section class="seg seg-left" [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" #rlaHome="routerLinkActive"
         [attr.aria-current]="rlaHome.isActive ? 'page' : null" title="Home" tabindex="0">
      <mat-icon svgIcon="world" class="seg-icon logo"></mat-icon>
    </section>

    <section class="seg" [routerLink]="['/rent-duration']" routerLinkActive="active" #rlaDur="routerLinkActive" [attr.aria-current]="rlaDur.isActive ? 'page' : null" title="Duration" tabindex="1">
      <div class="value"><i class="fa-solid fa-calendar-days"></i></div>
      <div class="seg-text">
        <div class="label">{{ rentDurationDayCount }}&nbsp;{{ 'HEADER.DAYS' | translate }}</div>
        <div class="sub ribbon-dates">
          <span class="date-start">
            <span class="date-label from">{{ 'HEADER.FROM' | translate }}</span>
            {{ rentDurationStart }}
          </span>
          <span class="date-dash"> – </span>
          <span class="date-end">
            <span class="date-label to">{{ 'HEADER.TO' | translate }}</span>
            {{ rentDurationEnd }}
          </span>
        </div>
      </div>
    </section>

    <section class="seg" [routerLink]="['/rent-persons']" routerLinkActive="active" #rlaPer="routerLinkActive" [attr.aria-current]="rlaPer.isActive ? 'page' : null" title="Personen" tabindex="2">
      <div class="value"><i class="fa-solid fa-people-group"></i></div>
      <div class="seg-text">
        <div class="label">{{ personCount }}&nbsp;{{ 'HEADER.PERSONS' | translate }}</div>
        <div class="sub ribbon-persons">
          @if (adultsCount) {
            <span class="rp-adults">
              {{ adultsCount }} {{ getTranslation('ADULT', adultsCount) }}
            </span>
          }
          @if (juniorsCount || childrenCount) {
            <span class="rp-sep">, </span>
            <span class="rp-children">
              {{ juniorsCount + childrenCount }} {{ getTranslation('CHILD', (juniorsCount + childrenCount)) }}
            </span>
          }
        </div>
      </div>
    </section>

    <section class="seg" [routerLink]="['/rent-location']" routerLinkActive="active" #rlaLoc="routerLinkActive" [attr.aria-current]="rlaLoc.isActive ? 'page' : null" title="Abholort" tabindex="3">
      <div class="value"><i class="fa-solid fa-location-dot"></i></div>
      <div class="seg-text">
        <div class="label">{{ 'HEADER.LOCATION' | translate }}</div>
        <div class="sub">{{ locationName }}</div>
      </div>
    </section>

    <section class="seg" [routerLink]="['/rent-products']" routerLinkActive="active" #rlaPro="routerLinkActive" [attr.aria-current]="rlaPro.isActive ? 'page' : null" title="Produkte" tabindex="4">
      <div class="value"><i class="fa-solid fa-person-skiing-nordic"></i></div>
      <div class="seg-text">
        <div class="label">{{ 'HEADER.PRODUCTS' | translate }}</div>
        <div class="sub">{{ products }}</div>
      </div>
    </section>

    <section class="seg" [routerLink]="['/rent-shopping-basket']" routerLinkActive="active" #rlaBas="routerLinkActive" [attr.aria-current]="rlaBas.isActive ? 'page' : null" title="Warenkorb" tabindex="5">
      <div class="value"><i class="fa-solid fa-cart-shopping"></i></div>
      <div class="seg-text small">
        <div class="label">{{ 'HEADER.CART' | translate }}</div>
        <div class="sub" *ngIf="getFinalPrice() as onlinePrice">€ {{ onlinePrice | number: '1.2-2' }}</div>
      </div>
    </section>

    <section class="seg seg-right">
      <div class="lang-login">
        <button class="flag" [matMenuTriggerFor]="languageMenu" tabindex="6">
          <mat-icon [svgIcon]="'flag-' + translateCode" class="flag-icon flag-round" aria-hidden="true"></mat-icon>
        </button>
        <mat-menu #languageMenu="matMenu">
          @for (lang of languages; track lang.code) {
            <button mat-menu-item (click)="switchLanguage(lang.code)" [disabled]="locale === lang.code">
              <mat-icon [svgIcon]="'flag-' + lang.code" class="menu-flag-icon" aria-hidden="true"></mat-icon>
              <span>{{ lang.labelKey | translate }}</span>
            </button>
          }
        </mat-menu>
        <button class="login" data-testid='btn-user-menu' [matMenuTriggerFor]="userMenu" tabindex="7">
          @if (isAuthenticated) {
            <mat-icon svgIcon="login" class="login-icon" matTooltip="{{ 'USER_PROFILE.LOGGED_IN_AS' | translate }}: {{ username }}"></mat-icon>
            }
          @else {
            <mat-icon svgIcon="login" class="login-icon" matTooltip="{{ 'USER_PROFILE.LOGIN' | translate }}"></mat-icon>
          }
        </button>
        <mat-menu #userMenu="matMenu">
            @if (isAuthenticated) {
            <button mat-menu-item data-testid='btn-user-info' (click)="openPage('user-info')">
                <mat-icon>manage_accounts</mat-icon>
                <span>{{ 'USER_PROFILE.PROFILE' | translate }}</span>
            </button>
            <button mat-menu-item data-testid='btn-user-reservations' (click)="openPage('reservations')">
                <mat-icon>shopping_basket</mat-icon>
                <span>{{ 'USER_PROFILE.RESERVATIONS' | translate }}</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item data-testid='btn-impressum' (click)="openPage('impressum')">
                <mat-icon>fingerprint</mat-icon>
                <span>{{ 'IMPRESSUM.TITLE' | translate }}</span>
            </button>
            <button mat-menu-item data-testid='btn-terms' (click)="openPage('terms')">
                <mat-icon>gavel</mat-icon>
                <span>{{ 'TERMS.TITLE' | translate }}</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item data-testid='btn-logout' (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>{{ 'USER_PROFILE.LOGOUT' | translate }}</span>
            </button>
            }
            @else {
            <button mat-menu-item data-testid='btn-impressum' (click)="openPage('impressum')">
                <mat-icon>fingerprint</mat-icon>
                <span>{{ 'IMPRESSUM.TITLE' | translate }}</span>
            </button>
            <button mat-menu-item data-testid='btn-terms' (click)="openPage('terms')">
                <mat-icon>gavel</mat-icon>
                <span>{{ 'TERMS.TITLE' | translate }}</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item data-testid='btn-login' (click)="login()">
                <mat-icon>login</mat-icon>
                <span>{{ 'USER_PROFILE.LOGIN' | translate }}</span>
            </button>
            }
        </mat-menu>
      </div>
    </section>
  </div>
</mat-toolbar>
